import { render } from "./SaleDashboard.vue?vue&type=template&id=330c367e"
import script from "./SaleDashboard.vue?vue&type=script&lang=js"
export * from "./SaleDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script